import React, { FC } from 'react'
import { Link } from 'react-router-dom'

const RulesSection: FC = () => {
    return (
        <section className='rules'>
            <div className="rules__info">
                <p>Перед відвідуванням залу, уважно ознайомтеся з правилами клубу</p>
            </div>
            <div className="rules__btn">
                <Link to={`/rules`}>Ознайомитись</Link>
            </div>
        </section>
    )
}

export default RulesSection